///test
(function ($) {


	$.fn.amxPrintMngr = function (clientId, enviromentId) {
		// private variables
		var _clientId;
		var _enviromentId;
		var _server_url;
		var _clientSetup = [];
		var _theClient;
		var _isReady = false;
		var _isConfigReady = false;
		var _timestamp = new Date().getUTCMilliseconds();
		var _modalhtml = '';
		var _forceReset = false;

		// private methods
		var _setConfig = function () {

			if (localStorage.getItem("print_" + _theClient.name) === null) {

				_clientSetup = { docs: [], version: _theClient.version };

				$.each(_theClient.docs, function (index, _doc) {
					_clientSetup.docs.push({
						id: _doc.id,
						name: _doc.name,
						printerName: '',
						copies: 1,
						options: _doc.options
					});
				});

				_isConfigReady = false;

			} else {

				_isConfigReady = true;
				_clientSetup = JSON.parse(localStorage.getItem("print_" + _theClient.name));

				if (_clientSetup.version !== _theClient.version) {
					localStorage.removeItem("print_" + _theClient.name);
					_isConfigReady = false;
				}

			}

		};
		var _showError = function () {

			$("#dvamxprint").html(_modalhtml);
			$("#dvamxprint").show();
			$(".print-close").click(function () {

				$("#dvamxprint").hide();
				$("#dvamxprint").html("");

			});


			$.get(_server_url + "templates/print/downloads.html?v=" + _timestamp, function (data) {
				var _jObj = $('<div/>').html(data).contents();
				$(".print-modal-body").append(_jObj.html());
			});
		};
		var _showConfig = function () {

			$("#dvamxprint").html(_modalhtml);
			$("#dvamxprint").show();
			$(".print-close").click(function () {

				$("#dvamxprint").hide();
				$("#dvamxprint").html("");

			});


			$.get(_server_url + "templates/print/config.html?v=" + _timestamp, function (data) {
				var _jObj = $('<div/>').html(data).contents();

				$.each(_clientSetup.docs, function (index, _row) {

					var _lst = "<select id='ddPrinters_" + index + "' onchange='onPrinterChange(" + _row.id + ",this)'>";
					var _selected = "";


					$.each(_printers, function (index) {

						_selected = (this == _row.printerName ? 'selected="selected"' : '');

						_lst = _lst + "<option " + _selected + ">" + this + "</option>";
					});

					_lst = _lst + "</select>";

					_jObj.find("#tblClientDocs").append('<tr><td >' + _row.name + '</td><td>' + _lst + '</td><td><input id="inCopies_' + index + '" onchange="inputNumChange(' + index + ')" type="number" max="10" min="1" step="1" value="' + _row.copies + '" ></td></tr>');
				});

				$(".print-modal-body").append(_jObj.html());


				$("#btnSave_Print_Config").click(function () {

					$.each(_clientSetup.docs, function (index, _row) {

						_row.printerName = $("#ddPrinters_" + index + " option:selected").text();
						_row.copies = $("#inCopies_" + index).val();
					});

					localStorage.setItem("print_" + _theClient.name, JSON.stringify(_clientSetup));
					$("#dvamxprint").hide();
					$("#dvamxprint").html("");
					_isConfigReady = true;


				});
				$("#btnClose_Print_Config").click(function () {

					$("#dvamxprint").hide();
					$("#dvamxprint").html("");

				});
			});




		};

		// public methods 
		this.initialize = function () {

			_clientId = clientId;
			_finalEnvo = "";
			_enviromentId = enviromentId;

			switch (_enviromentId) {
				case 0:
					_finalEnvo = ".dev";
					break;
				case 1:
					_finalEnvo = ".staging";
					break;
				default:
				// code block
			}

			_server_url = "https://ws" + _finalEnvo + ".aramex.net/printscanmanager/";

			$.get(_server_url + "templates/print/modal.html?v=" + _timestamp, function (data) {
				_modalhtml = data;

			});


			return this;

		};
		this.start = function () {

			var _this = this;

			JSPM.JSPrintManager.license_url = _server_url + 'jspm';
			JSPM.JSPrintManager.auto_reconnect = true;
			JSPM.JSPrintManager.start();
			return JSPM.JSPrintManager.WS.onStatusChanged = function () {

				if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {

					JSPM.JSPrintManager.getPrinters().then(function (e) {
						_printers = e;

						var _xmlhttp = new XMLHttpRequest();
						_xmlhttp.onreadystatechange = function () {
							if (this.readyState === 4 && this.status === 200) {
                
								_theClient = JSON.parse(this.responseText);
								_isReady = true;
								_setConfig();

								return _this.result({
									result: "success",
									resultId: 1,
									client: _theClient,
									printers: _printers
								});



							} else if (this.status >= 300) {

								return _this.result({
									result: "clientId not found",
									resultId: -2
								});

							}
						};
						_xmlhttp.open("GET", _server_url + "/clients/print/" + _clientId + ".json?v=" + _timestamp, true);
						_xmlhttp.send();


					});
				} else if (JSPM.JSPrintManager.websocket_status >= 1) {

					return _this.result({
						result: "failed to connect to JSPrintManager app",
						resultId: -1
					});
				}
			};

		};
		this.result = null;
		this.config = function () {

			if (_isReady) {
				_showConfig();
			} else {

				_showError();

			}

		};
		this.print = function (printObj) {
      
			if (_isReady) {

				var _targetPrinter = "";
				var _copies = 1;
				var _autoRotate = false;
				var _autoCenter = false;
				var _rotateDegreeId = 0;

				if (!_isConfigReady) {
					_showConfig();
					return;
				}

				$.each(_clientSetup.docs, function (index, _c) {

					if (_c.id === printObj.documentId) {
						_targetPrinter = _c.printerName;
						_copies = Number(_c.copies);
						//_autoCenter = $.parseJSON(_c.options.autoCenter);
						//_autoRotate = $.parseJSON(_c.options.autoRotate);
						//_rotateDegreeId = Number(_c.options.rotateDegreeId);
					}

				});




				var _cpj = new JSPM.ClientPrintJob();
				_cpj.clientPrinter = new JSPM.InstalledPrinter(_targetPrinter);

				var _print_file = null;

        if (printObj.fileName.indexOf('.pdf') !== -1) {
          
					_print_file = new JSPM.PrintFilePDF(printObj.fileData, JSPM.FileSourceType.Base64, printObj.fileName, _copies);
					_print_file.pageSizing = 1;
					_print_file.printAutoRotate = _autoRotate;
					_print_file.printAutoCenter = _autoCenter;
					_print_file.printRotation = _rotateDegreeId;
				} else {
					_print_file = new JSPM.PrintFile(printObj.fileData, JSPM.FileSourceType.Base64, printObj.fileName, _copies);
				}

				
				//var _print_file = new JSPM.PrintFileTXT('Lorem ipsum dolor sit amet, consectetur adipiscing elit. In dapibus purus vitae purus sollicitudin, nec semper tortor sodales. Sed sed urna quis tortor tempus congue nec a enim. Nunc non lectus lectus. Nam id lectus nec elit tempor congue. Donec placerat sapien ut enim blandit fermentum. Phasellus vitae efficitur purus. Morbi vitae laoreet ex, maximus cursus nulla. Donec varius mauris id facilisis scelerisque. Etiam at facilisis diam, et sagittis augue.', 'MyFile.txt', 1);
				_cpj.files.push(_print_file);
				_cpj.sendToClient();

			} else {

				_showError();

			}

		};

		return this.initialize();
	};


})(jQuery);

var _clientSetup = [];
var inputNumChange = function (index) {

	var _num = $("#inCopies_" + index).val();
	var _reg = /^([2-9]|1[0])$/;

	if (!_reg.test(_num)) {
		$("#inCopies_" + index).val(1);
	}

};
var onPrinterChange = function (docId, printer) {

	$.each(_clientSetup.docs, function (index, _row) {

		if (_row.id === docId) {
			_row.printerName = printer.value;
		}

	});

};
